const WebsocketNamespaceKeys = {
    companyId: 'company',
    userId: 'user',
    workspaceId: 'workspace',
    broadcast: 'broadcast'
};
export const getNamespaceParts = (namespace) => {
    const namespaceValueKey = Object.keys(namespace)[0];
    const namespaceName = WebsocketNamespaceKeys[namespaceValueKey];
    const namespaceId = namespace[namespaceValueKey];
    return {
        namespaceName,
        namespaceId
    };
};
export const buildTopic = ({ namespace, roomName }) => {
    const { namespaceName, namespaceId } = getNamespaceParts(namespace);
    return `${namespaceName}.${namespaceId}.${roomName}`;
};
//# sourceMappingURL=websocket.utils.js.map